<template>
    <div class="selectImportor-wrapper">
      <el-form>
         <el-button type="primary" size="mini" icon="el-icon-upload2" :loading="loading||floading"  @click="uploadFile">{{btnTxt}}</el-button>
         <input type="file" @change="getDataFromFile(this)" id="imFile" 
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
      </el-form>
      
    </div>
</template>

<script>
import moment from "moment";
import FileSaver from "file-saver";
import XLSX from "xlsx";
import libs from "../../../utils/libs";

export default {
  name: "selectImportor",
  props: ["floading"],
  data() {
    return {
      btnTxt: "选择文件",
      loading: false
    };
  },
  mounted() {
    this.imFile = document.getElementById("imFile");
  },
  methods: {
    uploadFile() {
      this.imFile.click();
    },
    getDataFromFile(file) {
      console.log("getDataFromFile");
      var _this = this;
      _this.btnTxt = "上传中..";
      _this.loading = true;
      this.file = event.currentTarget.files[0];
      var rABS = false; //是否将文件读取为二进制字符串
      var file = this.file;

      FileReader.prototype.readAsBinaryString = function(f) {
        var binary = "";
        var rABS = false; //是否将文件读取为二进制字符串
        var pt = this;
        var workbook; //读取完成的数据
        var reader = new FileReader();
        // reader.onprogress = function(e) {
        //   let total = file.size;
        //   _this.progress = e.loaded / total;
        //   console.log(e.loaded + "/" + total);
        // };

        reader.onloadend = function(e) {
          _this.btnTxt = "上传完成,正在处理";
          _this.loading = false;
          _this.$emit("onUploadComplete", {});
        };

        reader.onload = function(e) {
          try {
            var bytes = new Uint8Array(reader.result);
            var length = bytes.byteLength;
            for (var i = 0; i < length; i++) {
              binary += String.fromCharCode(bytes[i]);
            }
            if (rABS) {
              workbook = XLSX.read(btoa(fixdata(binary)), {
                //手动转化
                type: "base64"
              });
            } else {
              workbook = XLSX.read(binary, {
                type: "binary"
              });
            }
            _this.excelData = [];
          } catch (e) {
            console.log("importFile:文件类型不正确");
            return;
          }
          for (var sheet in workbook.Sheets) {
            if (workbook.Sheets.hasOwnProperty(sheet)) {
              _this.excelData = _this.excelData.concat(
                XLSX.utils.sheet_to_json(workbook.Sheets[sheet])
              );
            }
          }
          _this.$emit("onJsonReady", _this.excelData);
        };

        reader.readAsArrayBuffer(f);
      };

      var reader = new FileReader();
      if (rABS) reader.readAsArrayBuffer(file);
      else reader.readAsBinaryString(file);
    }
  },
  watch: {
    floading: function() {
      if (this.floading == false) {
        this.btnTxt = "选择文件";
        var file = document.getElementById("imFile");
        file.value = "";
        file.outerHTML = file.outerHTML;
      }
    }
  }
};
</script>

<style scoped>
#imFile {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/customComponents/selectImportor/selectImportor.vue